import { BLOCKS } from '@contentful/rich-text-types'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import get from 'lodash/get'

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: node => {
      const src = get(node, 'data.target.fields.file.url')
      const alt = get(node, 'data.target.fields.title')
      const description = get(node, 'data.target.fields.description')

      const descriptionTemplate = description
        ? `<span class="contentful-image-description">${description}</span>`
        : ''

      return `
      <div class="contentful-image-container">
        <img class="contentful-image" src="${src}" alt="${alt}" />
        ${descriptionTemplate}
      </div>
      `
    },
    /**
     * Only support "lesson" content type for now
     */

    [BLOCKS.EMBEDDED_ENTRY]: node => {
      console.log(node)
      const title = get(node, 'data.target.fields.title')
      const src = get(node, 'data.target.fields.desktopTileImage.fields.file.url')
      const alt = get(node, 'data.target.fields.desktopTileImage.fields.title')
      const lessonId = get(node, 'data.target.sys.id')

      return `
      <div class="contentful-entry-container" data-content-type="lesson" data-content-id="${lessonId}">
        <img class="contentful-entry-image" src="${src}" alt="${alt}" />
        <div class="contentful-entry-title">${title}</div>
      </div>
      `
    }
  }
}

/**
 * Transform a rich text document to its html equivalent
 *
 * @param {object} document - rich text document from contentful
 */
export function richTextToHtml(document) {
  return documentToHtmlString(document, options)
}
